import { useParams, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { getT } from "@/lib/translations";
import { useReveal } from "@/lib/useReveal";
import Preloader from "@/components/Preloader";
import SEOHead from "@/components/SEOHead";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import TrustBar from "@/components/TrustBar";
import Portfolio from "@/components/Portfolio";
import Artists from "@/components/Artists";
import Studio from "@/components/Studio";
import HowItWorks from "@/components/HowItWorks";
import QuoteForm from "@/components/QuoteForm";
import Reviews from "@/components/Reviews";
import Aftercare from "@/components/Aftercare";
import Location from "@/components/Location";
import FAQ from "@/components/FAQ";
import Blog from "@/components/Blog";
import Footer from "@/components/Footer";
import { FloatingWhatsApp, MobileStickyCTA } from "@/components/FloatingCTA";
import TattooInkCursor from "@/components/TattooInkCursor";

export const Landing = () => {
  const { lang: langParam } = useParams();
  const lang = langParam === "es" ? "es" : "en";
  useReveal();

  if (!langParam) return <Navigate to="/en" replace />;
  if (langParam !== "en" && langParam !== "es") return <Navigate to="/en" replace />;

  const t = getT(lang);

  return (
    <main className="bg-bendito-bg min-h-screen text-bendito-ink" data-testid="landing-page">
      <Preloader minDuration={2200} />
      <SEOHead lang={lang} />
      <TattooInkCursor />
      <Header t={t} lang={lang} />
      <Hero t={t} lang={lang} />
      <TrustBar t={t} />
      <Portfolio t={t} />
      <Artists t={t} />
      {/* Studio hidden until real studio photos are available */}
      {/* <Studio t={t} /> */}
      <HowItWorks t={t} lang={lang} />
      <QuoteForm t={t} lang={lang} />
      <Reviews t={t} />
      <Aftercare t={t} />
      <Blog t={t} lang={lang} />
      <Location t={t} />
      <FAQ t={t} />
      <Footer t={t} lang={lang} />
      <FloatingWhatsApp lang={lang} />
      <MobileStickyCTA t={t} lang={lang} />
      <div className="h-16 md:hidden" />
      <Toaster position="top-center" theme="dark" />
    </main>
  );
};

export default Landing;
